import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {IssueStatus} from "../../domain/entities/issue-status.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityDeletedPayload} from "../../message-broker/payloads/entity-deleted.payload";
import {CommandBus} from "../../services/command-bus.service";
import {DeleteIssueStatusCommand} from "../delete-issue-status.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

/**
 * Handles deletion of an issue status entity.
 * Sends the command to the backend and publishes an entity.deleted event.
 */
@CommandHandler(DeleteIssueStatusCommand)
@singleton()
export class DeleteIssueStatusCommandHandler implements ICommandHandler<IssueStatus> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker
    ) {
    }

    public async handle(command: ICommand<IssueStatus>): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        // The command already carries the full entity as its payload; no re-fetch.
        const entity = command.payload;
        if (!entity) {
            console.error(`Es wurde kein IssueStatus mit der UUID ${command.mainEntityUid} in der Persistenz gefunden.`);
            return;
        }

        this._messageBroker.publish<EntityDeletedPayload<IssueStatus>>({
            type: `entity.deleted`,
            identityHash: command.mainEntityUid,
            payload: {entity}
        });
    }
}
